import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=da4dff5e&"
import script from "./SettingsCard.vue?vue&type=script&lang=js&"
export * from "./SettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da4dff5e')) {
      api.createRecord('da4dff5e', component.options)
    } else {
      api.reload('da4dff5e', component.options)
    }
    module.hot.accept("./SettingsCard.vue?vue&type=template&id=da4dff5e&", function () {
      api.rerender('da4dff5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/SettingsCard.vue"
export default component.exports